import { buildModelManager } from "../builder.js";
const DefaultClinicalReviewArtifactSelection = {
  __typename: true,
  id: true,
  adminNotes: { markdown: true, truncatedHTML: true },
  adminReviewedAt: true,
  adminReviewedById: true,
  aiOutcome: true,
  createdAt: true,
  differences: true,
  exportedAt: true,
  humanOutcome: true,
  humanReviewPayload: true,
  institution: true,
  reviewerExplanation: { markdown: true, truncatedHTML: true },
  reviewerId: true,
  sourceRecordId: true,
  sourceSnapshot: true,
  sourceType: true,
  status: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "clinicalReviewArtifact";
const pluralModelApiIdentifier = "clinicalReviewArtifacts";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalReviewArtifactSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalReviewArtifactSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalReviewArtifactSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalReviewArtifactSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalReviewArtifactSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalReviewArtifactSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalReviewArtifactSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "clinicalReviewArtifactGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ClinicalReviewArtifactManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultClinicalReviewArtifactSelection,
  operations
);
export {
  ClinicalReviewArtifactManager,
  DefaultClinicalReviewArtifactSelection
};
//# sourceMappingURL=ClinicalReviewArtifact.js.map
